import { render, staticRenderFns } from "./vehicle.block.vue?vue&type=template&id=57fefcb7&scoped=true"
import script from "./vehicle.block.vue?vue&type=script&lang=js"
export * from "./vehicle.block.vue?vue&type=script&lang=js"
import style0 from "./vehicle.block.vue?vue&type=style&index=0&id=57fefcb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fefcb7",
  null
  
)

export default component.exports